import React from "react";
import MediaCard from "./deviceCard";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

export default function DeviceSelect(props) {
  const hash = window.location.hash;
  return hash === "#telehealth" ? (
    <Grid container justify="center" spacing={1}>
      <Grid item container justify="center">
        <Grid item xs={10}>
          <Typography variant="h5" align="justify">
            Telehealth with Motus devices is reimbursed by Medicare and most
            major private insurance.
            <br /> For questions, please call{" "}
            <a href="tel:4047385455"> 404-738-5355</a>.
          </Typography>
        </Grid>
      </Grid>
      <Grid item md={4}>
        <MediaCard
          peripheralType={"hand"}
          telehealth={true}
          handleFormChange={props.handleFormChange}
          handleDeviceSelect={props.handleDeviceSelect}
        />
      </Grid>
      <Grid item md={4}>
        <MediaCard
          peripheralType={"foot"}
          telehealth={true}
          handleFormChange={props.handleFormChange}
          handleDeviceSelect={props.handleDeviceSelect}
        />
      </Grid>
      <Grid item md={4}>
        <MediaCard
          peripheralType={"handfoot"}
          telehealth={true}
          handleFormChange={props.handleFormChange}
          handleDeviceSelect={props.handleDeviceSelect}
        />
      </Grid>
    </Grid>
  ) : (
    <Grid container justify="center" spacing={1} style={{ marginTop: "30px" }}>
      <Grid item md={4}>
        <MediaCard
          peripheralType={"hand"}
          telehealth={false}
          handleFormChange={props.handleFormChange}
          handleDeviceSelect={props.handleDeviceSelect}
        />
      </Grid>
      <Grid item md={4}>
        <MediaCard
          peripheralType={"foot"}
          telehealth={false}
          handleFormChange={props.handleFormChange}
          handleDeviceSelect={props.handleDeviceSelect}
        />
      </Grid>
      <Grid item md={4}>
        <MediaCard
          peripheralType={"handfoot"}
          telehealth={false}
          handleFormChange={props.handleFormChange}
          handleDeviceSelect={props.handleDeviceSelect}
        />
      </Grid>
    </Grid>
  );
}
